<hlm-dialog-header class="text-center">
    <img src="/logo-thalea.svg" alt="Logo" class="mx-auto mb-4 h-4">
    <h3 hlmDialogTitle class="text-center">
        {{ title() }}
    </h3>
</hlm-dialog-header>

<div class="flex flex-col gap-6 mt-6 items-center">
    <p class="text-center">
        {{ content() }}
    </p>
    <button
        (click)="closeDialog($event)"
        hlmBtn
        class="w-fit"
        >
        Ho capito
    </button>
</div>
